import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/tumour-research/dentalScreening";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	dentalScreening: {
		id: "ktx.dentalScreening.title",
		defaultMessage: "Fogászat"
	},
	result: {
		id: "ktx.dentalScreening.field.result",
		defaultMessage: "Eredmény"
	},
	comment: {
		id: "ktx.dentalScreening.field.comment",
		defaultMessage: "Megjegyzés"
	}
});

const fields: {
	[key: string]: FieldData;
} = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: {
			type: "button-group",
			props: { labels: resultMessages }
		}
	},
	comment: {
		type: "field",
		path: ["comment"],
		label: messages.comment,
		errorMessages: genericErrorMessages,
		input: { type: "textarea", props: {} }
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: fields.result }] },
		{ columns: [{ width: 12, field: fields.comment }] }
	]
};

export const node: LeafNode = {
	id: "ktx_dentalScreening",
	value: {
		schemaId: "dentalScreening",
		title: messages.dentalScreening,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
